import FormikInputText from "common/components/FormikFields/FormikInputText"
import Modal from "common/components/Modal/Modal"
import { Formik } from "formik"
import { useTranslation } from "react-i18next"
import * as Yup from "yup"
import Button from "../Button/Button"

const ModalCrearEtiqueta = ({
  visible,
  onHide,
  onSubmit,
  options = [],
  data,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  return (
    <Modal
      header='Nueva etiqueta'
      visible={visible}
      onHide={onHide}
      size='small'
    >
      <Formik
        initialValues={{
          etiqueta: data?.etiqueta,
        }}
        validationSchema={Yup.object().shape({
          etiqueta: Yup.string()
            .nullable()
            // @ts-expect-error TS(2345): Argument of type 'DefaultTFuncReturn' is not assig...
            .required(t("errors.fieldEmpty"))
            // @ts-expect-error TS(2345): Argument of type 'DefaultTFuncReturn' is not assig...
            .test("", t("errors.listSucessTag"), (value) =>
              options.every(
                // @ts-expect-error TS(7031): Binding element 'label' implicitly has an 'any' ty...
                ({ label }) => label.toLowerCase() !== value?.toLowerCase()
              )
            ),
        })}
        onSubmit={onSubmit}
      >
        {({ handleSubmit, isValid }) => {
          return (
            <form
              onSubmit={handleSubmit}
              className='text-left p-fluid p-formgrid'
            >
              <div className='p-field'>
                {/* TODO: i18n */}
                <label htmlFor='etiqueta'>Etiqueta</label>

                <FormikInputText
                  placeholder=''
                  name='etiqueta'
                />
              </div>

              <Button
                className='mt-4'
                type='submit'
                onClick={handleSubmit}
                disabled={!isValid}
              >
                Añadir
              </Button>
            </form>
          )
        }}
      </Formik>
    </Modal>
  )
}

export default ModalCrearEtiqueta
